import eventBus from '@refapp/eventbus-js';

// Constants
const HEADER_WRAPPER = '.oap-header__wrapper';
const OPAQUE = '-opaque';
const SEARCH_IS_ACTIVE = 'search--is-active';

// Helper functions
function removeActiveClasses() {
  const ACTIVE = '-active';
  const selectors = [
    '.navigationList.-active',
    '.navigation__panelWrapper.-active',
    '.navigationList__item.-active',
    '.navigation__burger.-active',
  ];

  selectors.forEach((selector) => {
    const element = document.querySelector(selector);
    if (element) {
      element.classList.remove(ACTIVE);
    }
  });
}

function closeOpenedOverlay() {
  const overlay = document.querySelector('.overlay.overlay--open');
  if (overlay) {
    overlay.classList.remove('overlay--open');
  }
}

function updateHeaderOpacity(scrollPosition) {
  const header = document.querySelector(HEADER_WRAPPER);
  if (!header) return;

  if (document.body.getBoundingClientRect().top !== 0) {
    header.classList.add(OPAQUE);
  }

  if (scrollPosition <= 500) {
    header.classList.remove(OPAQUE);
  }
}

function setupSearchValidation(searchInput, searchButton, minLength) {
  const DISABLED = 'disabled';

  searchButton.setAttribute(DISABLED, true);

  searchInput.addEventListener('keyup', () => {
    if (searchInput.value.length > minLength - 1) {
      searchButton.removeAttribute(DISABLED);
      return;
    }

    if (searchInput.value.length < minLength && !searchButton.hasAttribute(DISABLED)) {
      searchButton.setAttribute(DISABLED, true);
    }
  });
}

function setupFormSubmit(searchForm, searchInput, minLength) {
  searchForm.addEventListener('submit', (event) => {
    if (searchInput.value.length < minLength) {
      event.preventDefault();
    }
  });
}

function setupSearchInputClick(searchInput) {
  searchInput.addEventListener('click', () => {
    setTimeout(() => {
      document.body.classList.add('headerIsShown');
    }, 500);
  });
}

function resetSearchState(searchCheckbox, searchInput, openSearch, event) {
  if (event) {
    event.preventDefault();
  }
  setTimeout(() => {
    searchInput.value = '';
    searchInput.blur();
    searchCheckbox.checked = false;
    if (openSearch) {
      openSearch.focus();
    }
  }, 300);
}

function activateSearchHeader() {
  const header = document.querySelector(HEADER_WRAPPER);
  if (header) {
    header.classList.add(SEARCH_IS_ACTIVE);
  }
}

function deactivateSearchHeader(scrollPosition) {
  const header = document.querySelector(HEADER_WRAPPER);
  if (header) {
    header.classList.remove(SEARCH_IS_ACTIVE);
  }
  updateHeaderOpacity(scrollPosition);
}

function handleOpenSearch(searchCheckbox, searchInput) {
  const OVERLAY_ACTIVE = 'overlay--active';
  const NO_SCROLL = 'noScroll';
  const MENU_IS_ACTIVE = 'menu--is-active';

  eventBus.emit('closeNav', false);
  const oBody = document.querySelector('body');
  oBody.classList.remove(OVERLAY_ACTIVE, NO_SCROLL, MENU_IS_ACTIVE);
  searchCheckbox.checked = true;
  activateSearchHeader();
  updateHeaderOpacity(0);
  removeActiveClasses();
  closeOpenedOverlay();

  setTimeout(() => {
    searchInput.focus();
  }, 300);
}

function createKeyupHandler(searchCheckbox, searchInput) {
  const SEARCH_FORM_ITEM = 'oap-search__form-item';
  const SEARCH_SUGGESTIONS_LINK = 'oap-search-suggestions-list__link';

  return function onKeyupHandler(event) {
    const { code, target } = event;
    const isSearchElement =
      target.classList.contains(SEARCH_FORM_ITEM) ||
      target.classList.contains(SEARCH_SUGGESTIONS_LINK);

    if (code === 'Tab' && !isSearchElement) {
      searchInput.value = '';
      searchInput.blur();
      searchCheckbox.checked = false;
      document.removeEventListener('keyup', onKeyupHandler);
    }
  };
}

function closeSearchTab(searchCheckbox, searchInput, openSearch, event) {
  const SEARCH_SUGGESTIONS_CLOSE_EVENT = 'search-suggestions::close';
  const scrollPosition = Math.abs(document.body.getBoundingClientRect().top);

  resetSearchState(searchCheckbox, searchInput, openSearch, event);
  eventBus.emit(SEARCH_SUGGESTIONS_CLOSE_EVENT);
  deactivateSearchHeader(scrollPosition);
}

export default {
  // eslint-disable-line
  name: 'search',
  beforeMount: (el, binding) => {
    // DOM structure shared between header-search.hbs and main-search.hbs
    const searchForm = el.querySelector('.oap-search__form');
    const searchInput = el.querySelector('.oap-search__input');
    const searchButton = el.querySelector('.oap-search__button');

    // DOM structure that is only specific to header-search.hbs
    const openSearch = el.querySelector('.oap-search__label.-open');
    const closeSearch = el.querySelector('.oap-search__label.-close');
    const clickOverlay = el.querySelector('.oap-click-overlay');
    const searchCheckbox = el.querySelector('.oap-search__checkbox');

    // remove native browser validation from search input
    searchInput.removeAttribute('pattern');

    // Setup validation and event handlers
    setupSearchValidation(searchInput, searchButton, binding.value);
    setupFormSubmit(searchForm, searchInput, binding.value);
    setupSearchInputClick(searchInput);

    /* istanbul ignore next */
    if (openSearch) {
      const onKeyupHandler = createKeyupHandler(searchCheckbox, searchInput);

      openSearch.addEventListener('click', () => {
        handleOpenSearch(searchCheckbox, searchInput);
        setTimeout(() => {
          document.addEventListener('keyup', onKeyupHandler);
        }, 300);
      });
    }

    /* istanbul ignore next */
    if (closeSearch) {
      closeSearch.addEventListener('click', (event) => {
        closeSearchTab(searchCheckbox, searchInput, openSearch, event);
      });
    }

    /* istanbul ignore next */
    if (clickOverlay && searchCheckbox) {
      clickOverlay.addEventListener('click', () => {
        closeSearchTab(searchCheckbox, searchInput, openSearch);
      });
    }

    /* istanbul ignore next */
    searchInput.addEventListener('keydown', (event) => {
      const { key } = event;
      if (key === 'Escape') {
        closeSearchTab(searchCheckbox, searchInput, openSearch, event);
      }
    });
  },
};
